import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "../../../redux/actions/modals";
import { State } from "../../../redux/reducers/root";
import { DropdownOption } from "../dropdown";
import ModalTemplate from "./template";

interface ModalData {
  title?: string;
  options: DropdownOption[];
  onChange(option: DropdownOption): void;
  value?: string | number;
}
const DropdownModal = () => {
  const modals = useSelector((state: State) => state.modals);
  const dispatch = useDispatch();
  const { title, options, value, onChange } = modals.data as ModalData;
  const onClick = (option: DropdownOption) => {
    onChange(option);
    dispatch(hideModal());
  };
  return (
    <ModalTemplate title={title} icon={title && "fa fa-caret-down"}>
      {title && <hr />}
      <ul>
        {options?.map((option) => (
          <li className={`p-2 ${option.value === value && "bg-pkc-primary-15"}`} onClick={() => onClick(option)}>
            {option.label}
          </li>
        ))}
      </ul>
    </ModalTemplate>
  );
};

export default DropdownModal;
